import React, { useRef } from 'react';

import World from '../../../images/pages/cases/ai-driven/world.png';
import Pin1 from '../../../images/pages/cases/ai-driven/pin-1.png';

const AiDrivenSolution = () => {
    const blockRef = useRef(null);
    const worldRef = useRef(null);
    const pin1Ref = useRef(null);

    return (
        <div className="animation-block" ref={blockRef}>
            <div className="animation-block__img" >
                <img src={World} className="world" alt="world" ref={worldRef} width="400" height="400" />
                <img src={Pin1} className="pin" alt="sad man" ref={pin1Ref} width="105" height="145" />
            </div>
            <svg className="path path--1" width="559" height="319" viewBox="0 0 559 319" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path id="motionPath"
                    d="M387.218 166.804c19.285-88.803-342.16 96.427-275.728-40.438 66.432-136.865 258.63 159.65 363.244 57.529 28.397-39.425 62.219-126.286-29.66-158.334C235.131-42.792 75.5 47.165 55.526 86.79c-19.974 39.628-22.335 68.316-11.026 89.71 48.4 113.6 178.657 108.442 237.736 91.664 87.431-27.335 233.19-101.371 116.778-178.835-12.187-7.352-31.515-18.255-50.114-26.26-18.6-8.005-35.945-12.961-57.128-16.716-21.183-3.755-45.474-7.397-61.438-6.706-23.405 1.014-43.19 4.99-62.512 16.596-17.466 10.49-32.903 22.377-45.271 38.35-13.734 17.737-25.968 33.74-28.707 49.306-22.965 85.47 32.036 100.258 62.407 96.968C255.252 204.363 268 123.197 298 86.792c65.6-85.367 178.103-37.006 224.551 3.026C569 129.85 597.971 278.464 426.873 249.37c-19.231-5.505-39.265-13.894-54.778-26.831-69.124-95.97-131.198-146.3-153.594-159.468C196.613 51.01 38.501 36 8.22 129.85c-30.28 93.85 35.816 148.396 108.281 174.807 98.993 36.079 233.474 3.163 270.717-137.853Z"
                    stroke="white" strokeDasharray="2 2" fill="none" />

                <g transform="translate(0 -50)">
                    <animateMotion
                        dur="50s"
                        begin="0s"
                        fill="freeze"
                        keyPoints="0;1"
                        keyTimes="0;1"
                        calcMode="linear"
                        repeatCount="indefinite"
                        rotate="auto">
                        <mpath href="#motionPath" />
                    </animateMotion>
                    <g strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)">
                        <path stroke="#FF84C0" strokeWidth="1.241"
                            d="M21.178 48.38c11.256 0 20.38-9.135 20.38-20.405 0-11.27-9.124-20.405-20.38-20.405C9.923 7.57.798 16.706.798 27.975c0 11.27 9.125 20.405 20.38 20.405Z" />
                        <path stroke="url(#b)" strokeWidth=".621"
                            d="M33.95 40.76c7.054-7.062 7.054-18.512 0-25.575-7.053-7.062-18.49-7.062-25.543 0-7.053 7.063-7.053 18.513 0 25.575 7.054 7.062 18.49 7.062 25.543 0Z" />
                        <path stroke="#FF84C0" strokeWidth=".621"
                            d="M22.88 4.027V5.92M19.477 5.919V4.027M31.488 8.416l.85-1.214a.974.974 0 0 1 1.357-.24l2.925 2.05c.44.31.548.918.24 1.36l-.854 1.22" />
                        <path stroke="#EE4C8E" strokeWidth=".621" d="M21.179 9.89v2.107" />
                        <path stroke="#EA3E82" strokeWidth=".621" d="m12.148 12.313 1.052 1.823" />
                        <path stroke="#E93A7D" strokeWidth=".621" d="m5.537 18.93 1.821 1.053" />
                        <path stroke="#EA3E82" strokeWidth=".621" d="M3.117 27.973H5.22" />
                        <path stroke="#EE4C8E" strokeWidth=".621" d="m5.537 37.014 1.821-1.053" />
                        <path stroke="#F45E9E" strokeWidth=".621" d="m12.148 43.633 1.052-1.824" />
                        <path stroke="#F86EAD" strokeWidth=".621" d="M21.179 46.06v-2.107" />
                        <path stroke="#FF84C0" strokeWidth=".621"
                            d="m30.21 43.633-1.052-1.824M36.82 37.014 35 35.961M39.24 27.973h-2.103" />
                        <path stroke="#F86EAD" strokeWidth=".621" d="M36.82 18.93 35 19.983" />
                        <path stroke="#F45E9E" strokeWidth=".621" d="m30.21 12.313-1.052 1.823" />
                        <path stroke="#FF84C0" strokeWidth="1.241"
                            d="M25.341.621h-8.324a.909.909 0 0 0-.909.91V3.12c0 .502.407.91.909.91h8.324a.909.909 0 0 0 .909-.91V1.53a.909.909 0 0 0-.909-.909ZM22.6 28.207a1.44 1.44 0 1 0-2.843-.462 1.44 1.44 0 1 0 2.843.462ZM23 26.576 31.576 18" />
                    </g>
                    <defs>
                        <linearGradient id="b" x1="35.5" x2="5.024" y1="39" y2="19.463" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#FF84C0" />
                            <stop offset="1" stopColor="#E9397D" />
                        </linearGradient>
                        <clipPath id="a">
                            <path fill="#fff" d="M.179 0h42v49h-42z" />
                        </clipPath>
                    </defs>
                </g>

                <g transform="translate(0 -50)">
                    <animateMotion
                        dur="30s"
                        begin="-20s"
                        fill="freeze"
                        keyPoints="0.66;1"
                        keyTimes="0;1"
                        calcMode="linear"
                        repeatCount="indefinite"
                        rotate="auto">
                        <mpath href="#motionPath" />
                    </animateMotion>
                    <g strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)">
                        <path stroke="#FF84C0" strokeWidth="1.241"
                            d="M21.178 48.38c11.256 0 20.38-9.135 20.38-20.405 0-11.27-9.124-20.405-20.38-20.405C9.923 7.57.798 16.706.798 27.975c0 11.27 9.125 20.405 20.38 20.405Z" />
                        <path stroke="url(#b)" strokeWidth=".621"
                            d="M33.95 40.76c7.054-7.062 7.054-18.512 0-25.575-7.053-7.062-18.49-7.062-25.543 0-7.053 7.063-7.053 18.513 0 25.575 7.054 7.062 18.49 7.062 25.543 0Z" />
                        <path stroke="#FF84C0" strokeWidth=".621"
                            d="M22.88 4.027V5.92M19.477 5.919V4.027M31.488 8.416l.85-1.214a.974.974 0 0 1 1.357-.24l2.925 2.05c.44.31.548.918.24 1.36l-.854 1.22" />
                        <path stroke="#EE4C8E" strokeWidth=".621" d="M21.179 9.89v2.107" />
                        <path stroke="#EA3E82" strokeWidth=".621" d="m12.148 12.313 1.052 1.823" />
                        <path stroke="#E93A7D" strokeWidth=".621" d="m5.537 18.93 1.821 1.053" />
                        <path stroke="#EA3E82" strokeWidth=".621" d="M3.117 27.973H5.22" />
                        <path stroke="#EE4C8E" strokeWidth=".621" d="m5.537 37.014 1.821-1.053" />
                        <path stroke="#F45E9E" strokeWidth=".621" d="m12.148 43.633 1.052-1.824" />
                        <path stroke="#F86EAD" strokeWidth=".621" d="M21.179 46.06v-2.107" />
                        <path stroke="#FF84C0" strokeWidth=".621"
                            d="m30.21 43.633-1.052-1.824M36.82 37.014 35 35.961M39.24 27.973h-2.103" />
                        <path stroke="#F86EAD" strokeWidth=".621" d="M36.82 18.93 35 19.983" />
                        <path stroke="#F45E9E" strokeWidth=".621" d="m30.21 12.313-1.052 1.823" />
                        <path stroke="#FF84C0" strokeWidth="1.241"
                            d="M25.341.621h-8.324a.909.909 0 0 0-.909.91V3.12c0 .502.407.91.909.91h8.324a.909.909 0 0 0 .909-.91V1.53a.909.909 0 0 0-.909-.909ZM22.6 28.207a1.44 1.44 0 1 0-2.843-.462 1.44 1.44 0 1 0 2.843.462ZM23 26.576 31.576 18" />
                    </g>
                    <defs>
                        <linearGradient id="b" x1="35.5" x2="5.024" y1="39" y2="19.463" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#FF84C0" />
                            <stop offset="1" stopColor="#E9397D" />
                        </linearGradient>
                        <clipPath id="a">
                            <path fill="#fff" d="M.179 0h42v49h-42z" />
                        </clipPath>
                    </defs>
                </g>

                <g transform="translate(0 -13)">
                    <animateMotion
                        dur="30s"
                        begin="-10s"
                        fill="freeze"
                        keyPoints="0.33;1"
                        keyTimes="0;1"
                        calcMode="linear"
                        repeatCount="indefinite"
                        rotate="auto">
                        <mpath href="#motionPath" />
                    </animateMotion>
                    <g filter="url(#a)">
                        <rect width="17" height="11" x="4.5" y=".5" stroke="#027BC4" rx="2.5" shapeRendering="crispEdges" />
                    </g>
                    <path stroke="#fff" d="m5.75 2 6.596 5.48a1 1 0 0 0 1.263.013L20.5 2" />
                    <path stroke="#027BC4" strokeWidth=".8" d="m5.125 3 7.182 6.417a1 1 0 0 0 1.317.013L21.125 3" />
                    <path stroke="#0278BF" d="m6 11 4-4M20 11l-4-4" />
                    <g filter="url(#b)">
                        <rect width="15.5" height="9.5" x="5.25" y="1.25" stroke="#fff" strokeWidth=".5" rx="1.75"
                            shapeRendering="crispEdges" />
                    </g>
                    <defs>
                        <filter id="a" width="26" height="20" x="0" y="0" colorInterpolationFilters="sRGB"
                            filterUnits="userSpaceOnUse">
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                            <feOffset dy="4" />
                            <feGaussianBlur stdDeviation="2" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_9794_168" />
                            <feBlend in="SourceGraphic" in2="effect1_dropShadow_9794_168" result="shape" />
                        </filter>
                        <filter id="b" width="24" height="18" x="1" y="1" colorInterpolationFilters="sRGB"
                            filterUnits="userSpaceOnUse">
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                            <feOffset dy="4" />
                            <feGaussianBlur stdDeviation="2" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_9794_168" />
                            <feBlend in="SourceGraphic" in2="effect1_dropShadow_9794_168" result="shape" />
                        </filter>
                    </defs>
                </g>

                <g transform="translate(0 -13)">
                    <animateMotion
                        dur="10s"
                        begin="-30s"
                        fill="freeze"
                        keyPoints="0.88;1"
                        keyTimes="0;1"
                        calcMode="linear"
                        repeatCount="indefinite"
                        rotate="auto">
                        <mpath href="#motionPath" />
                    </animateMotion>
                    <g filter="url(#a)">
                        <rect width="17" height="11" x="4.5" y=".5" stroke="#027BC4" rx="2.5" shapeRendering="crispEdges" />
                    </g>
                    <path stroke="#fff" d="m5.75 2 6.596 5.48a1 1 0 0 0 1.263.013L20.5 2" />
                    <path stroke="#027BC4" strokeWidth=".8" d="m5.125 3 7.182 6.417a1 1 0 0 0 1.317.013L21.125 3" />
                    <path stroke="#0278BF" d="m6 11 4-4M20 11l-4-4" />
                    <g filter="url(#b)">
                        <rect width="15.5" height="9.5" x="5.25" y="1.25" stroke="#fff" strokeWidth=".5" rx="1.75"
                            shapeRendering="crispEdges" />
                    </g>
                    <defs>
                        <filter id="a" width="26" height="20" x="0" y="0" colorInterpolationFilters="sRGB"
                            filterUnits="userSpaceOnUse">
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                            <feOffset dy="4" />
                            <feGaussianBlur stdDeviation="2" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_9794_168" />
                            <feBlend in="SourceGraphic" in2="effect1_dropShadow_9794_168" result="shape" />
                        </filter>
                        <filter id="b" width="24" height="18" x="1" y="1" colorInterpolationFilters="sRGB"
                            filterUnits="userSpaceOnUse">
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                            <feOffset dy="4" />
                            <feGaussianBlur stdDeviation="2" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_9794_168" />
                            <feBlend in="SourceGraphic" in2="effect1_dropShadow_9794_168" result="shape" />
                        </filter>
                    </defs>
                </g>
            </svg>
        </div>
    );
};

export default AiDrivenSolution;

